(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[99256],{

/***/ 99256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Benefits; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/longrangemovers/benefits/styles.module.scss
var styles_module = __webpack_require__(69000);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/longrangemovers/benefits/icons/Couch.tsx


function Couch() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        fill: "none",
        viewBox: "0 0 80 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_261",
                style: {
                    maskType: "alpha"
                },
                width: "80",
                height: "80",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H80V80H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#244880",
                mask: "url(#mask0_0_261)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M74.828 29.976c-2.858 0-5.176 2.308-5.176 5.153 0 1.365.538 2.604 1.41 3.526v7.51H8.883V38.55a5.122 5.122 0 001.47-3.592c0-2.846-2.319-5.153-5.177-5.153C2.318 29.804 0 32.11 0 34.957c0 .191.012.38.034.568-.009.11-.034.214-.034.325v15.107c0 .135.028.258.039.389-.007.119-.039.23-.039.347 0 3.053 2.796 5.527 6.246 5.527h1.953v6.31h3.074l1.489-6.31h53.99l1.492 6.31h3.073v-6.31h2.377c3.448 0 6.246-2.474 6.246-5.527 0-.117-.03-.23-.04-.344.01-.133.04-.257.04-.392V35.872a5.2 5.2 0 00.06-.743c.003-2.845-2.314-5.152-5.172-5.152z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M69.02 39.89c0 2.658-2.095 4.816-4.681 4.816H15.661c-2.585 0-4.68-2.157-4.68-4.817V22.071c0-2.66 2.095-4.816 4.68-4.816h48.678c2.586 0 4.68 2.156 4.68 4.816v17.818z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var icons_Couch = (Couch);

;// CONCATENATED MODULE: ./src/components/longrangemovers/benefits/icons/Clock.tsx


function PotentialInjury() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        fill: "none",
        viewBox: "0 0 80 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_265",
                style: {
                    maskType: "alpha"
                },
                width: "80",
                height: "80",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H80V80H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_265)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#244880",
                    d: "M71.817 38.62a1.38 1.38 0 100 2.76H80C79.284 62.36 62.359 79.284 41.38 80v-8.183a1.38 1.38 0 10-2.76 0V80C17.64 79.284.714 62.359 0 41.38h8.183a1.38 1.38 0 100-2.76H0C.716 17.64 17.641.716 38.62 0v8.183a1.38 1.38 0 102.76 0V0C62.36.716 79.284 17.641 80 38.62h-8.183zm-19.76 13.54L41.38 39.496V20.744a1.38 1.38 0 10-2.762 0V40c0 .326.115.64.325.89l11.001 13.05a1.378 1.378 0 001.945.166 1.38 1.38 0 00.167-1.945z"
                })
            })
        ]
    });
}
/* harmony default export */ var Clock = (PotentialInjury);

;// CONCATENATED MODULE: ./src/components/longrangemovers/benefits/icons/DollarSign.tsx


function DollarSign() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        fill: "none",
        viewBox: "0 0 80 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_256",
                style: {
                    maskType: "alpha"
                },
                width: "80",
                height: "80",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H80V80H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#244880",
                mask: "url(#mask0_0_256)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M77.643 39.742c.296 20.293-16.17 36.895-36.452 36.895-16.24 0-30.03-10.649-34.728-25.312a.462.462 0 00-.556-.31l-2.384.616a.933.933 0 01-1.11-1.228l3.613-9.643a.936.936 0 011.483-.382l7.849 6.685a.93.93 0 01-.373 1.61l-2.721.703a.473.473 0 00-.332.604c4.082 12.224 15.65 21.064 29.259 21.064 17.583 0 31.776-14.747 30.8-32.49-.824-14.976-12.64-27.356-27.602-28.876-14.492-1.472-27.677 7.193-32.312 20.403-1.26 3.591-6.511 1.658-5.33-1.743C12.186 12.67 27.786 2.38 44.941 4.11c18.256 1.841 32.434 17.333 32.7 35.632l.001-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M41.031 15.783c-13.366 0-24.238 10.873-24.238 24.239 0 13.365 10.873 24.238 24.238 24.238 13.366 0 24.239-10.873 24.239-24.239 0-13.365-10.873-24.238-24.239-24.238zm-4.66 21.442h8.993c4.96 0 9.299 3.734 9.63 8.684.363 5.428-3.95 9.96-9.301 9.96h-1.398a.466.466 0 00-.467.467v2.33a.933.933 0 01-.932.933h-3.729a.933.933 0 01-.932-.932v-2.331a.466.466 0 00-.467-.466H36.37c-4.786 0-8.742-3.626-9.264-8.275a.942.942 0 01.933-1.048h3.769c.453 0 .821.33.914.773a3.735 3.735 0 003.648 2.957h9.157c1.946 0 3.688-1.42 3.877-3.356a3.734 3.734 0 00-3.711-4.102H36.7c-4.96 0-9.3-3.735-9.63-8.685-.364-5.428 3.949-9.96 9.3-9.96h1.399a.466.466 0 00.466-.467v-2.33c0-.515.417-.933.932-.933h3.729c.514 0 .932.418.932.933v2.33c0 .258.21.466.467.466h1.398c4.786 0 8.742 3.626 9.264 8.275a.942.942 0 01-.933 1.048h-3.769c-.453 0-.821-.33-.914-.773a3.735 3.735 0 00-3.648-2.956h-9.157c-1.946 0-3.688 1.419-3.877 3.356a3.734 3.734 0 003.711 4.102z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var icons_DollarSign = (DollarSign);

;// CONCATENATED MODULE: ./src/components/longrangemovers/benefits/index.tsx






const benefitsList = [
    {
        title: "Your Budget",
        description: "Start by determining your maximum affordable spend. Then, add some flexibility for unforeseen expenses or delays, to ensure a more realistic budget.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clock, {})
    },
    {
        title: "Custom Items",
        description: "If you have unique, heavy, or delicate items such as custom furniture or pianos, it's important to choose movers with expertise in handling these items.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Couch, {})
    },
    {
        title: "Timeline",
        description: "Faster movers might be limited by tight schedules, while having more time for your move broadens your choice of companies.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_DollarSign, {})
    }, 
];
function Benefits() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `max-w-7xl mx-auto  ${(styles_module_default()).container}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: `text-center font-bold text-xl capitalize lg:text-2xl mb-14  ${(styles_module_default()).mainTitle}`,
                children: "How to Choose the Right Moving Company for You"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: `text-center text-lg capitalize lg:text-xl mb-14  `,
                children: "Selecting the right moving company is crucial for a smooth relocation experience. When researching, consider factors such as:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col items-center lg:flex-row gap-4 justify-between px-4 text-center",
                children: benefitsList.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: `w-full flex flex-col justify-center align-center lg:w-[30%] py-11 px-6 gap-6 lg:gap-11 max-w-[350px] ${(styles_module_default()).item}`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mx-auto mb-[14px]",
                                children: item.icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "font-bold text-base lg:text-lg capitalize",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-normal text-sm",
                                children: item.description
                            })
                        ]
                    }, index))
            })
        ]
    });
}


/***/ }),

/***/ 69000:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","container":"styles_container__N8MFr","item":"styles_item__ogZo4","mainTitle":"styles_mainTitle__WJ5mk"};

/***/ })

}]);